import { BankAccountDetails } from '@40seas/entities/bank-account';
import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { WireBankAccountDetailsSchema } from '@40seas/entities/payment-methods';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export const AirwallexGlobalAccountSchema = WithBaseEntitySchema(
    z.object({
        providerId: z.string(),
        accountId: z.string(),
        currency: EnumSchema(Currency),
        country: z.string(),
        bankAccountDetails: z.array(WireBankAccountDetailsSchema),
    }),
).strict();

export class AirwallexGlobalAccount extends FromSchema(AirwallexGlobalAccountSchema) implements BaseEntity {
    id: string;
    providerId: string;
    accountId: string;
    currency: Currency;
    country: string;
    bankAccountDetails: BankAccountDetails[];
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
